const noSubcategory = 'noSubcategory';
const gummiesCategory = 'gummies';

/* GET ALL COMBINATIONS FROM SELECTED FILTER OPTIONS */
const getCombinations = (arr, pre) => {
  pre = pre || '';
  if (!arr.length) {
    return pre;
  }
  var ans = arr[0].reduce(function(ans, value) {
    return ans.concat(getCombinations(arr.slice(1), pre + `${value} `));
  }, []);

  return ans;
}

/* GET REGEX FILTER SECTION FROM COMBINATION */
const getRegExSTR = (filterParams) => {
  const arr = filterParams.split(' ');
  let filterSTR = '';

  arr.map((item) => {
    if (item !== '') {
      filterSTR += `(?=.*${item})`
    }

    return null;
  });

  return filterSTR;
}

/* GET REGEX FILTER WHIT ALL COMBINATIONS */
const getFilter = (filter) => {
  const filterCopy = {...filter};

  /* CHECK WHEN CATEGORY DOESN´T HAVE SUBCATEGORY OR SUBCATEGORY ADDED BUT GUMMIES NOT IN CATEGORY */
  if (filterCopy.category && filterCopy.subcategory) {
    if (filterCopy.category.length > 1 && filterCopy.category.includes(gummiesCategory)) {
      // console.log('none needs to be added to filter.subcategory');
      filterCopy.subcategory.push(noSubcategory);
      // console.log('updatedFilter: ', filter);
    } else if (!filterCopy.category.includes(gummiesCategory)) {
      // console.log('GUMMIES NOT IN CATEGORY ARR');
      filterCopy.category.push(gummiesCategory);
      filterCopy.subcategory.push(noSubcategory);
    }
  } 

  const filterValues = Object.values(filterCopy);
  // console.log('filterValues: ', filterValues);
  const combinations = getCombinations(filterValues);

  // console.log('COMBINATIONS: ', combinations);

  let regExSTR = '';

  combinations.map((comb, indx) => {
    if (indx !== 0) {
      regExSTR += `|${getRegExSTR(comb)}`;
    } else {
      regExSTR += getRegExSTR(comb);
    }

    return null;
  });

  // console.log('regExSTR: ', regExSTR);

  const filterRegEx = new RegExp(regExSTR);

  // console.log('filterRegEx: ', filterRegEx);

  return filterRegEx;
};

/* GET STRING FROM ARRAY */
const getProductSTR = (fields) => {
  let str = '';

  fields.map(item => {
    if (item) {
  
      if (item.length >= 0) {
        item.map(itm => str += `${itm.slug.current}/`);

      } else {
        str += `${item.slug.current}/`;
        
      }

    }

    return null;
  });

  return str.slice(0, -1);
};

/* CHECK IF PRODUCT MATCH THE REGEX FILTER */
const checkMatch = (product, filter) => {
  const states = product.infoPerState.map(item => item.state);
  // const fields = [product.category, product.subcategory, product.effects, product.lineages, product.typeOfStore, states];
  const fields = [product.effects, product.lineages, product.typeOfStore, states];

  const productSTR = getProductSTR(fields);
  
  // const filter = getFilter(filterObj);

  // console.log('productSTR: ', productSTR);

  const didMatch = productSTR.match(filter);
  // console.log(didMatch ? 'MATCH' : 'NO MATCH');

  return didMatch;
}

/* CHECK IF OBJECT IS EMPTY */
const isObjEmpty = (objectToCheck) => {
  const isEmpty = Object.entries(objectToCheck).length === 0;

  return isEmpty;
};

export { noSubcategory, getFilter, checkMatch, isObjEmpty };

